import { render, staticRenderFns } from "./EnteringCode.vue?vue&type=template&id=35d81844&scoped=true&"
import script from "./EnteringCode.vue?vue&type=script&lang=ts&"
export * from "./EnteringCode.vue?vue&type=script&lang=ts&"
import style0 from "./EnteringCode.vue?vue&type=style&index=0&id=35d81844&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d81844",
  null
  
)

export default component.exports